export class Address {
    // Original property names
    line1?: string;
    line2?: string;
    zip?: string;
    city?: string;
    country?: string;
    region?: string;

    // Keep compatibility with new implementation
    get street(): string | undefined {
        return this.line1;
    }

    set street(value: string | undefined) {
        this.line1 = value;
    }

    get state(): string | undefined {
        return this.line2;
    }

    set state(value: string | undefined) {
        this.line2 = value;
    }

    get zipCode(): string | undefined {
        return this.zip;
    }

    set zipCode(value: string | undefined) {
        this.zip = value;
    }

    constructor(data: Partial<Address> = {}) {
        this.line1 = data.line1 || data.street || '';
        this.line2 = data.line2 || data.state || '';
        this.zip = data.zip || data.zipCode || '';
        this.city = data.city || '';
        this.country = data.country || '';
        this.region = data.region || '';
    }
}